export default {
  ctaText: "Show my financial overview",
  sidePanelSubtitle: "We have sales information regarding the first batch.",
  sidePanelTitle: "Hold on a moment!",
  tagLabel: "Middle of the day"
};
